import React from 'react';
import { COLORS } from '../../styles/tokens';

function abbreviation(code) {
  if (code === 'nb') return 'NO';
  if (code === 'other') return '+';
  return String(code).toUpperCase();
}

// «Dokumentert»-merke og språkforkortelser for en sjåfør. Returnerer null når det ikke er noe å vise.
export default function DriverTrust({ documented, languages }) {
  const langs = Array.isArray(languages) ? languages : [];
  if (!documented && langs.length === 0) return null;
  return (
    <span style={styles.wrap}>
      {documented && (
        <span style={{ ...styles.chip, background: COLORS.successBg, color: COLORS.successText }}
              title="Tippi har kontrollert forsikring, løyve og YSK.">Dokumentert</span>
      )}
      {langs.length > 0 && (
        <span style={{ ...styles.chip, background: COLORS.surfaceHover, color: COLORS.textDark }}>
          {langs.map(abbreviation).join(' · ')}
        </span>
      )}
    </span>
  );
}

const styles = {
  wrap: { display: 'inline-flex', alignItems: 'center', gap: 6, flexWrap: 'wrap' },
  chip: { borderRadius: 20, padding: '2px 8px', fontSize: 10.5, fontWeight: 700 },
};
